
import './style.scss'

interface AdBannerBasicProps {
	message: string
	onClick?: () => void
}

function AdBannerBasic({message, onClick}: AdBannerBasicProps) {

	const onBannerClick = () => {
		if (onClick) {
			onClick()
		}
	}

	return (
		<div 
			className='ad-banner-basic'
			onClick={() => { onBannerClick() }}
		>
			{message}
		</div>
	)
}

export default AdBannerBasic